"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { useHostStore } from "@shared/src/stores/useHostStore";

export default function PageTracker({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const sdk = useHostStore(state => state.sdk);
  const activeAddress = sdk?.auth.getAddress();

  useEffect(() => {
    // Generate a session-specific anonymous ID if no user is logged in
    const anonymousId =
      sessionStorage.getItem("clarity_anonymous_id") || `anon_${Math.random().toString(36).substring(2, 15)}`;

    const { analytics } = useHostStore.getState();
    if (!activeAddress) {
      sessionStorage.setItem("clarity_anonymous_id", anonymousId);
      analytics?.clarity?.identifyUser(anonymousId, undefined, pathname || "/", "Anonymous User");
    } else {
      analytics?.clarity?.identifyUser(activeAddress, undefined, pathname || "/");
      analytics?.firebase?.setUserId(activeAddress);
    }

    analytics?.firebase?.pageView(pathname?.split("/").pop() || "Home", pathname || "/");
  }, [pathname, searchParams, activeAddress]);

  return <>{children}</>;
}
